import React from "react";
import heroBg from "../images/jackson-david-unsplash.png";
import "./hero.scss";

const sectionBg = {
  background: `url(${heroBg}) no-repeat center/cover`,
};

function Hero() {
  return (
    <section style={sectionBg} className="hero">
      <div className="hero__container">
        <h1 className="main-heading">Nothing but green lights ahead</h1>
        {/* todo: Add url to Spectrum Acceptance payment */}
        <a
          href="https://spectrum.accountportalonline.com/"
          className="btn--blue"
        >
          Make A Payment
        </a>
      </div>
    </section>
  );
}

export default Hero;
